// Generated by BUCKLESCRIPT VERSION 2.2.2, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.statelessComponent("Cell");

function make(color, onClick, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var identifier = color ? (
          color[0] !== 0 ? "black" : "white"
        ) : "";
      return React.createElement("div", {
                  className: "cell " + identifier,
                  onClick: onClick
                });
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/cell.re
// module id = 31
// module chunks = 0